
    document.addEventListener('DOMContentLoaded', function () {
        const nav_popup = document.getElementById('nav_popup');
        const nav_closePopupButton = document.getElementById('nav_closePopup');

        // Hiển thị popup một lần trong mỗi phiên
        if (!sessionStorage.getItem('nav_popupShown')) {
            nav_popup.classList.add('nav_active');
            sessionStorage.setItem('nav_popupShown', 'true');
        }

        // Đóng popup khi nhấn nút "x"
        nav_closePopupButton.addEventListener('click', function () {
            nav_popup.classList.remove('nav_active');
        });
    });

// Fix email to sub and snackbar

function showSnackbar() {
          const snackbar = document.createElement('div');
          snackbar.textContent = 'Thank you, your email has been added to our mailing list.';
          snackbar.style.position = 'fixed';
          snackbar.style.bottom = '20px';
          snackbar.style.left = '50%';
          snackbar.style.transform = 'translateX(-50%)';
          snackbar.style.backgroundColor = '#323232';
          snackbar.style.color = '#fff';
          snackbar.style.padding = '10px 20px';
          snackbar.style.borderRadius = '5px';
          snackbar.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.3)';
          snackbar.style.zIndex = '10000000';
          snackbar.style.opacity = '0';
          snackbar.style.transition = 'opacity 0.5s ease';
      
          document.body.appendChild(snackbar);
      
          // Hiển thị snackbar
          setTimeout(() => {
              snackbar.style.opacity = '1';
          }, 100);
      
          // Ẩn snackbar sau 3 giây
          setTimeout(() => {
              snackbar.style.opacity = '0';
              setTimeout(() => {
                  snackbar.remove();
              }, 500);
          }, 3000);
      }

        document.addEventListener('DOMContentLoaded', function () {
            function isValidEmail(email) {
                // Kiểm tra email hợp lệ bằng regex
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailRegex.test(email);
            }
        
            function checkForms() {
                // Lấy tất cả các form có action là /contact#contact_form
                const forms = document.querySelectorAll('form[action="/contact#contact_form"]');
        
                forms.forEach(form => {
                    // Tìm trường input[type="email"] trong form
                    const emailInput = form.querySelector('input[type="email"]');
                    if (emailInput) {
                        const emailValue = emailInput.value.trim(); // Lấy giá trị email
                        if (isValidEmail(emailValue)) {
                            showSnackbar(); // Gọi hàm showSnackbar nếu email hợp lệ
                        }
                    }
                });
            }
        
            // Gọi hàm kiểm tra sau khi trang đã tải
            checkForms();
        });

    
        function setupSubscribeEvents(selector) {
          const sourceInput = document.querySelector(selector);
          const targetInput = document.querySelector('.section-newsletter .signup-form input[type="email"]');
        
          if (!sourceInput || !targetInput) {
            console.error('Input elements not found. Please check the selectors.');
            return;
          }
        
          // Add event listener to track changes in the source input
          sourceInput.addEventListener('input', () => {
            targetInput.value = sourceInput.value; // Update target input with source input's value
            console.log(`Updated target input: ${targetInput.value}`);
          });
        }

        window.addEventListener('DOMContentLoaded', function () {
            setupSubscribeEvents('footer .signup-form input[type="email"]');
        });